import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ValidationAPI from '../../Lib/Api/validation';
import useStyles from './style';
import methods from './constant';
import FormMethodTwoFactorAuth from './FormMethodTwoFactorAuth';
import CodeInputTwoFactorAuth from './CodeInputTwoFactorAuth';
import { useGet2faMethods } from '../../Lib/Hooks/validation.hooks';

export default function TwoFactorAuth(props) {
  const { classes } = useStyles();
  const { onAuthenticated = () => {} } = props;

  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [error, setError] = useState(null);
  const [method, setMethod] = useState(methods.EMAIL);
  const { error: errorMethods, data: resMethods } = useGet2faMethods();

  const getCode = () => {
    setLoading(true);
    ValidationAPI.get2faCode({ method, vendorId: props.vendor.id })
      .then(() => {
        setCodeSent(true);
        setError(null);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  const verify = (code, setErrorCb) => {
    setLoading(true);

    ValidationAPI.verify2faCode({ code, method })
      .then(() => onAuthenticated())
      .catch((err) => {
        setErrorCb(err.message);
        setLoading(false);
      });
  };

  return (
    <div className={classes.root}>
      {!codeSent && resMethods ? (
        <FormMethodTwoFactorAuth
          method={method}
          getCode={getCode}
          setMethod={setMethod}
          possibleMethods={resMethods}
        />
      ) : null}
      {codeSent && (
        <CodeInputTwoFactorAuth
          method={{ [method]: methods[method] }}
          verify={verify}
          setCodeSent={setCodeSent}
          loading={loading}
        />
      )}
      <span className={classes.error}>{error || errorMethods}</span>
    </div>
  );
}

TwoFactorAuth.propTypes = {
  onAuthenticated: PropTypes.func,
  vendor: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};
